"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A class built with the specific purpose of looking after the telemetry of all applications withing AP
 */
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var applicationinsights_react_js_1 = require("@microsoft/applicationinsights-react-js");
var appInsights = null;
/**
 * The first setup that must be called in order for AppInsights to work
 *
 * @param {string} instrumentationKey - the key used to setup app insights
 * @param {react node} history - an instance of the react history
 */
var setupTelemetry = function (instrumentationKey, history) {
    var _a;
    if (!instrumentationKey || !history)
        return;
    var reactPlugin = new applicationinsights_react_js_1.ReactPlugin();
    appInsights = new applicationinsights_web_1.ApplicationInsights({
        config: {
            instrumentationKey: instrumentationKey,
            extensions: [reactPlugin],
            extensionConfig: (_a = {},
                _a[reactPlugin.identifier] = { history: history },
                _a),
        },
    });
    // return the app insights instance
    return appInsights.loadAppInsights();
};
/**
 * Used to track events on the application
 *
 * @param {string} eventName - the name of the event you want to track, this can be any string
 * @param {object} eventProps - any extra information to be sent to application insights
 */
var trackEvent = function (eventName, eventProps) {
    if (eventProps === void 0) { eventProps = {}; }
    // If the insights setup has yet to be completed reject for now
    if (!eventName || !appInsights)
        return;
    appInsights.trackEvent({
        name: eventName,
        properties: eventProps,
    });
};
/**
 * Export Telemetry as a single object for easier recognition
 */
exports.Telemetry = {
    setup: setupTelemetry,
    trackEvent: trackEvent,
};
//# sourceMappingURL=APTelemetry.js.map